
export class mail {
    emailTo:string[];
    subject:string;
    message:string;
    aliasName:string;
    bccMail:string[];
    ccMail:string[];
    attachment:string;
    attachmentName:string;

    constructor(data?: Partial<mail>) {
        Object.assign(this, data);
      }
}